// extracted by mini-css-extract-plugin
export default {"title":"sjIov","imageLink":"j91wo","loading":"ynAXu","container":"SBUGb","imageContainer":"waEmW","aside":"eEJiE","link":"Sqqu_","smallImageOnly":"yTqSp"};